// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__lc00h","col":"ProductsDashboard_col__+xZjz","card":"ProductsDashboard_card__VQq7x"};